<div class="container-fluid mt-4">
  <div class="row">

    <div class="col-lg-12 ">

      <div class="row">
        <div class="col-6 mb-2">

        </div>

        <div class="col-12 d-flex justify-content-end gap-2 mt-3">

          <button type="button" class="btn btn-outline-secondary px-4 shadow-sm" (click)="back()">
            <i class="fa fa-arrow-left me-1"></i>
            Back
          </button>

          <button type="button" class="btn btn-primary px-4 shadow-sm" (click)="previewAudit()" *ngIf="isReadOnly">
            <i class="fa fa-eye me-1"></i>
            Preview
          </button>

        </div>

      </div>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-lg-4">
      <div class="card">

        <div class="card-header">


          <h5 class="election-title mb-0">Checklist</h5>

          <div class="d-flex align-items-end">

            <button type="button" class="btn btn-success" (click)="downloadDocument(newUpload.documentPath)"
              style="margin-bottom: 10px;" [style.display]="!isReadOnly  ? 'none' : 'inline-block'"
              title="Download Report">
              <i class="bi bi-download me-1"></i> Report
            </button>

            <button type="button" title="Audit Status & History" class="btn btn-info btn-sm"
              style="margin-bottom: 10px;" (click)="auditStatus(trans?.iSocietyDetailsId,trans?.iAllotAuditorID)"
              data-bs-toggle="modal" data-bs-target="#AuditorStatus">
              <i class="bi bi-clock-history"></i> Audit Status
            </button>

          </div>

        </div>
        <div class="card-body">

          <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <button class="nav-link text-start active" id="v-pills-SocietyInformation-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-SocietyInformation" type="button" role="tab"
              aria-controls="v-pills-SocietyInformation" aria-selected="true"> Society
              Information</button>
            <button class="nav-link text-start" id="v-pills-MembersEmployeeDetails-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-MembersEmployeeDetails" type="button" role="tab"
              aria-controls="v-pills-MembersEmployeeDetails" aria-selected="false">
              Members and
              Employee
              Details</button>
            <button class="nav-link text-start" id="v-pills-SocietyServices-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-SocietyServices" type="button" role="tab" aria-controls="v-pills-SocietyServices"
              aria-selected="false"> Society Services</button>
            <button class="nav-link text-start" id="v-pills-AuditDetails-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-AuditDetails" type="button" role="tab" aria-controls="v-pills-AuditDetails"
              aria-selected="false"> Audit Details</button>
            <button class="nav-link text-start" id="v-pills-BalanceSheet-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-BalanceSheet" type="button" role="tab" aria-controls="v-pills-BalanceSheet"
              aria-selected="false"> Balance Sheet</button>
            <button class="nav-link text-start" id="v-pills-OtherDetails-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-OtherDetails" type="button" role="tab" aria-controls="v-pills-OtherDetails"
              aria-selected="false"> Other Details</button>
          </div>



        </div>
      </div>



    </div>
    <div class="col-lg-8">
      <div class="tab-content" id="SocietyChecklist">
        <div class="tab-pane fade show active" id="v-pills-SocietyInformation" role="tabpanel"
          aria-labelledby="v-pills-SocietyInformation-tab" tabindex="0">
          <div class="card">
            <div class="card-header">
              <h5 class="election-title">🗂️ Society Information</h5>

            </div>
            <div class="card-body ">
              <div class="row">


                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Society Name</label>
                          <input type="text" class="form-control" [value]="filteredData?.societyName"
                            placeholder="Society Name" disabled />
                        </div>

                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Address</label>
                          <input type="text" class="form-control" [value]="filteredData?.address"
                            placeholder="Enter Address" disabled />
                        </div>

                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Registration No.</label>
                          <input type="text" class="form-control" [value]="filteredData?.registrationNo"
                            placeholder="Enter Registration No" disabled />
                        </div>

                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Registration Date </label>
                          <input type="text" class="form-control"
                            [value]="filteredData?.registrationDate | date : 'dd/MM/yyyy'"
                            placeholder="Enter Registration Date" disabled />
                        </div>
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Society Category</label>
                          <input type="text" class="form-control" [value]="filteredData?.level"
                            placeholder="Society Category" disabled />
                        </div>
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Society Type</label>
                          <input type="text" class="form-control" [value]="filteredData?.societyType"
                            placeholder="Society Type" disabled />
                        </div>
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Society Kind<span class="text-danger">*</span></label>
                          <select class="form-control" [(ngModel)]="building.iSKindid" id="iSKindid" name="iSKindid"
                            #iSKindid="ngModel" required disabled>
                            <option value="0" selected disabled>Select Kind</option>
                            <!-- First Option: Current Category -->
                            <option [value]="filteredData?.category">
                              {{
                              filteredData?.category === 3
                              ? "Credit"
                              : filteredData?.category === 4
                              ? "Non-credit"
                              : filteredData?.category
                              }}
                            </option>

                            <!-- Second Option: Opposite Category -->
                            <option [value]="
                          filteredData?.category === 3
                            ? 4
                            : filteredData?.category === 4
                            ? 3
                            : ''
                        ">
                              {{
                              filteredData?.category === 3
                              ? "Non-credit"
                              : filteredData?.category === 4
                              ? "Credit"
                              : ""
                              }}
                            </option>
                          </select>

                          <!-- Validation error message -->
                          <div *ngIf="iSKindid.invalid && iSKindid.touched" class="text-danger">
                            Please select the society kind.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-header" style="border-left:0px;">
                      <h5 class="election-title">Society Status</h5>

                    </div>
                    <div class="card-body">
                      <div class="row">


                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Status of Societies
                            <span class="text-danger">*</span></label>
                          <select class="form-control" [(ngModel)]="building.statusSocieties" [disabled]="isReadOnly"
                            id="statusSocieties" name="statusSocieties" #statusSocieties="ngModel" required>
                            <option value="" disabled>Select Status</option>
                            <option *ngFor="let sta of statuss" [value]="sta.name">
                              {{ sta.name }}
                            </option>
                          </select>
                          <div *ngIf="statusSocieties.invalid && statusSocieties.touched" class="text-danger">
                            Status is required.
                          </div>
                        </div>



                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-header" style="border-left:0px;">
                      <h5 class="election-title">Society Building Details</h5>

                    </div>
                    <div class="card-body">
                      <div class="row">


                        <!-- Society Building -->
                        <div class="col-lg-6 col-md-6 mb-2">
                          <label class="form-label m-0">Society Building<span class="text-danger">*</span></label>
                          <select class="form-control" [(ngModel)]="building.iSocietyBuilding" [disabled]="isReadOnly"
                            id="iSocietyBuilding" name="iSocietyBuilding" #iSocietyBuilding="ngModel" required>
                            <option [ngValue]="''" disabled>Select Building</option>
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                          </select>
                          <!-- <div *ngIf="iSocietyBuilding.invalid && iSocietyBuilding.touched"
                                              class="text-danger">Please select whether the society has a building.</div> -->
                        </div>

                        <!-- Building Type and Remarks (conditionally displayed if 'Yes' is selected for Society Building) -->
                        <div class="col-lg-6 col-md-6 mb-2" *ngIf="building.iSocietyBuilding === true">
                          <label class="form-label m-0">Building Type<span class="text-danger">*</span></label>
                          <select class="form-control" [(ngModel)]="building.buildingType" [disabled]="isReadOnly"
                            id="buildingType" name="buildingType" required>
                            <option value="" disabled selected>Building Type</option>
                            <option value="Own Building">Own Building</option>
                            <option value="Rented">Rented</option>
                            <option value="Rent Free">Rent Free</option>
                            <option value="Leased Building">Leased Building</option>
                            <option value="Building Provided By The Govt">
                              Building Provided By The Govt </option>
                          </select>
                          <!-- <div *ngIf="!building.buildingType" class="text-danger">Please select the
                                              building type.</div> -->
                        </div>
                        <div class="col-lg-12 mb-2" *ngIf="building.iSocietyBuilding === true">
                          <label class="form-label m-0">Remarks<span class="text-danger">*</span></label>
                          <textarea class="form-control" [(ngModel)]="building.buildingRemarks"
                            placeholder="Enter Remarks" required [disabled]="isReadOnly" maxlength="250"></textarea>
                          <!-- <div *ngIf="!building.buildingRemarks" class="text-danger">Please enter remarks.
                                          </div> -->
                        </div>

                      </div>
                    </div>
                  </div>
                </div>


                <div class="col-lg-12">
                  <div class="card">

                    <div class="card-header" style="border-left:0px;">
                      <h5 class="election-title">Society Land Details</h5>

                    </div>
                    <div class="card-body">
                      <div class="row">


                        <!-- Land Details -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Land Details<span class="text-danger">*</span></label>
                          <select class="form-control" [(ngModel)]="building.iLandDetailType"
                            (change)="onLandDetailChange()" id="iLandDetailType" name="iLandDetailType"
                            #iLandDetailType="ngModel" [disabled]="isReadOnly" required>
                            <option [ngValue]="''" disabled>Select Land</option>
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                          </select>
                          <!-- <div *ngIf="iLandDetailType.invalid && iLandDetailType.touched" class="text-danger">
                                          Please select land details.</div> -->
                        </div>

                        <!-- Possession Type, Area, Remarks (conditionally displayed if 'Yes' is selected for Land Details) -->
                        <div class="col-lg-4 col-md-6 mb-2" *ngIf="building.iLandDetailType === true">
                          <label class="form-label m-0">Type of Possession<span class="text-danger">*</span></label>
                          <select class="form-control" [disabled]="isReadOnly" [(ngModel)]="building.possessionType"
                            id="possessionType" name="possessionType" required>
                            <option value="" disabled>Possession Type</option>
                            <option value="Owned">
                              Owned
                            </option>
                            <option value="Leased">
                              Leased
                            </option>
                            <option value="Land allotted by govt.">
                              Land allotted by govt.
                            </option>
                          </select>
                          <!-- <div *ngIf="!building.possessionType" class="text-danger">Please select possession
                                          type.</div> -->
                        </div>
                        <div class="col-lg-4 col-md-6 mb-2" *ngIf="building.iLandDetailType === true">
                          <label class="form-label m-0">Area( in Sq feet)<span class="text-danger">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="building.landArea"
                            (paste)="onPasteNumber($event)" name="landArea" #landAreaModel="ngModel"
                            (ngModelChange)="checkMaxLength(building, 'landArea', 4)"
                            placeholder="Enter land area in sq. ft." (paste)="allowOnlyNonNegativePaste($event)"
                            (keypress)="allowOnlyNonNegativeIntegers($event)" maxlength="4" required
                            [disabled]="isReadOnly" />

                          <div class="text-danger" *ngIf="errors['landArea']">
                            {{ errors['landArea'] }}
                          </div>

                          <!-- <div *ngIf="!building.landArea" class="text-danger">Please enter the area.</div> -->
                        </div>
                        <div class="col-lg-12 mb-2" *ngIf="building.iLandDetailType === true">
                          <label class="form-label m-0">Remarks<span class="text-danger">*</span></label>
                          <textarea class="form-control" [(ngModel)]="building.landRemark" placeholder="Enter Remarks"
                            required [disabled]="isReadOnly" maxlength="250"></textarea>
                          <!-- <div *ngIf="!building.landRemark" class="text-danger">Please enter land remarks.
                                      </div> -->
                        </div>

                        <!-- Save Button -->
                        <div class="col-md-12 mb-2 text-end">
                          <!-- <input type="button" class="btn btn-secondary" value="Back"> &nbsp; -->
                          <!-- <input type="button" class="btn btn-primary" [style.display]="
                        hasSubmittedRemark ? 'none' : 'inline-block'" [disabled]="!BuildingformIsValid()"
                          (click)="submitBuildingForm()" value="Save & Next" /> -->
                          <button type="button" class="btn btn-primary"
                            [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                            [disabled]="!BuildingformIsValid() || isSubmittingBuilding" (click)="submitBuildingForm()">

                            <span *ngIf="!isSubmittingBuilding">Save & Next</span>
                            <span *ngIf="isSubmittingBuilding">
                              <span class="spinner-border spinner-border-sm me-1" role="status"
                                aria-hidden="true"></span>
                              Saving...
                            </span>
                          </button>

                        </div>


                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>


          </div>
        </div>

        <div class="tab-pane fade" id="v-pills-MembersEmployeeDetails" role="tabpanel"
          aria-labelledby="v-pills-MembersEmployeeDetails-tab" tabindex="0">
          <div class="card">
            <div class="card-header">
              <h5 class="election-title">🧑‍🏫 Members and Employee Details</h5>
            </div>
            <div class="card-body">
              <form #empForm="ngForm" (ngSubmit)="submitEmpForm()" novalidate>
                <div class="row">



                  <div class="col-lg-12">
                    <div class="card">
                      <div class="card-header" style="border-left:0px;">
                        <h5 class="election-title">General Member Details</h5>
                      </div>
                      <div class="card-body">
                        <div class="row">


                          <!-- General Member Fields -->
                          <div class="col-lg-4 col-md-6 mb-2" *ngIf="
                      filteredData?.level === 'Secondary and Apex Institutes'
                    ">
                            <label class="form-label m-0">
                              Total Society Members <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" name="totalMember" [(ngModel)]="empList.totalMember"
                              #totalMember="ngModel" required [disabled]="isReadOnly" placeholder="Society Members"
                              (keypress)="allowOnlyNonNegativeIntegers($event)"
                              (paste)="allowOnlyNonNegativePaste($event)" maxlength="5"
                              (ngModelChange)="checkMaxLength(empList, 'totalMember', 5)" />
                            <div class="text-danger" *ngIf="
                        totalMember.invalid &&
                        (totalMember.touched || totalMember.dirty)
                      ">
                              Total Member is required.
                            </div>
                            <div class="text-danger" *ngIf="errors['totalMember']">
                              {{ errors['totalMember'] }}
                            </div>
                          </div>

                          <div class="col-lg-4 col-md-6 mb-2" *ngIf="
                      filteredData?.level === 'Secondary and Apex Institutes'
                    ">
                            <label class="form-label m-0">Cooperative Societies No
                              <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" name="coOperativeSocietyNo"
                              [(ngModel)]="empList.coOperativeSocietyNo" #coOperativeSocietyNo="ngModel"
                              [disabled]="isReadOnly" required maxlength="5"
                              (keypress)="allowOnlyNonNegativeIntegers($event)"
                              (paste)="allowOnlyNonNegativePaste($event)" placeholder="Cooperative Societies No"
                              (ngModelChange)="checkMaxLength(empList, 'coOperativeSocietyNo', 5)"
                              (paste)="onPasteNumber($event)" />
                            <div class="text-danger" *ngIf="
                        coOperativeSocietyNo.invalid &&
                        (coOperativeSocietyNo.touched ||
                          coOperativeSocietyNo.dirty)
                      ">
                              <div *ngIf="coOperativeSocietyNo.errors?.['required']">
                                Co-OperativeSociety No Required.
                              </div>

                              <div class="text-danger" *ngIf="errors['coOperativeSocietyNo']">
                                {{ errors['coOperativeSocietyNo'] }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Total Individuals Number
                              <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" name="totalIndividualNo"
                              [(ngModel)]="empList.totalIndividualNo" #totalIndividualNo="ngModel" required
                              [disabled]="isReadOnly" placeholder="Individuals Number" maxlength="5"
                              (keypress)="allowOnlyNonNegativeIntegers($event)"
                              (paste)="allowOnlyNonNegativePaste($event)"
                              [ngClass]="{ 'border-danger': hasIndividualMismatch }" />
                            <div class="text-danger" *ngIf="
                        totalIndividualNo.invalid &&
                        (totalIndividualNo.touched || totalIndividualNo.dirty)
                      ">
                              <div *ngIf="totalIndividualNo.errors?.['required']">
                                Total Individuals Number Required.
                              </div>
                              <div *ngIf="totalIndividualNo.errors?.['maxlength']">
                                Maximum value is 99999.
                              </div>
                            </div>
                          </div>

                          <!-- 
                          <div class="col-lg-12">
                            <hr>
                            <h5 class="election-title">Based on Trained and Non-Trained:</h5>
                          </div>
                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">General Trained Member No<span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" name="generaltrainedEmployees"
                              [(ngModel)]="empList.generaltrainedEmployees" #generaltrainedEmployees="ngModel"
                              (input)="validateEmployeeTotals('GTM')" [disabled]="isReadOnly"
                              (keypress)="allowOnlyPositiveIntegers($event)" maxlength="5"
                              placeholder="General Trained Member No" (keypress)="validateNumber($event)"
                              (paste)="onPasteNumber($event)" [ngClass]="{ 'border-danger': hasIndividualMismatch }" />
                            <div class="text-danger" *ngIf="
                        generaltrainedEmployees.invalid &&
                        (generaltrainedEmployees.touched || generaltrainedEmployees.dirty)
                      ">

                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">General Non-Trained Member No<span
                                class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" name="generalnonTrainedEmployees"
                              [(ngModel)]="empList.generalnonTrainedEmployees" #generalnonTrainedEmployees="ngModel"
                              (input)="validateEmployeeTotals('GNT')" [disabled]="isReadOnly"
                              (keypress)="allowOnlyPositiveIntegers($event)" (paste)="onPasteNumber($event)"
                              maxlength="5" [ngClass]="{ 'border-danger': hasIndividualMismatch }"
                              placeholder="General Non-Trained Member No" (keypress)="validateNumber($event)" />
                            <div class="text-danger" *ngIf="
                        generalnonTrainedEmployees.invalid &&
                        (generalnonTrainedEmployees.touched || generalnonTrainedEmployees.dirty)
                      ">

                            </div>
                          </div> -->
                          <div class="col-lg-12">
                            <hr>
                            <h5 class="election-title">Based on Gender:</h5>
                          </div>
                          <!-- Gender Fields -->
                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Male Member No<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" name="maleMember" [(ngModel)]="empList.maleMember"
                              #maleMember="ngModel" [disabled]="isReadOnly" maxlength="5"
                              (keypress)="allowOnlyPositiveIntegers($event)" (keypress)="validateNumber($event)"
                              (input)="validateEmployeeTotals('GM')" (paste)="onPasteNumber($event)"
                              [ngClass]="{ 'border-danger': hasIndividualMismatch }" placeholder="Male Member Number" />
                            <div class="text-danger" *ngIf="
                        maleMember.invalid &&
                        (maleMember.touched || maleMember.dirty)
                      ">


                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Female Member No<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" name="femaleMember"
                              [(ngModel)]="empList.femaleMember" #femaleMember="ngModel" [disabled]="isReadOnly"
                              placeholder="Female Member Number" (input)="validateEmployeeTotals('GF')" maxlength="5"
                              (keypress)="allowOnlyPositiveIntegers($event)" (keypress)="validateNumber($event)"
                              (paste)="onPasteNumber($event)" required
                              [ngClass]="{ 'border-danger': hasIndividualMismatch }" />
                            <div class="text-danger" *ngIf="
                        femaleMember.invalid &&
                        (femaleMember.touched || femaleMember.dirty)
                      ">

                              <div *ngIf="femaleMember.errors?.['max']">
                                Maximum value is 99999.
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Other Member No<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" name="otherMember" [(ngModel)]="empList.otherMember"
                              #otherMember="ngModel" [disabled]="isReadOnly" placeholder="Other Member Number"
                              (input)="validateEmployeeTotals('GOM')" maxlength="5"
                              (keypress)="allowOnlyPositiveIntegers($event)" (keypress)="validateNumber($event)"
                              (paste)="onPasteNumber($event)" required
                              [ngClass]="{ 'border-danger': hasIndividualMismatch }" />
                            <div class="text-danger" *ngIf="
                        otherMember.invalid &&
                        (otherMember.touched || otherMember.dirty)
                      ">
                              <div *ngIf="otherMember.errors?.['max']">
                                Maximum value is 99999.
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12">
                            <hr>
                            <h5 class="election-title">Based on Category:</h5>
                          </div>
                          <!-- Caste Category Fields -->
                          <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">General Member No<span class="text-danger">*</span> </label>
                            <input type="text" class="form-control" name="generalMemberNo"
                              [(ngModel)]="empList.generalMemberNo" #generalMemberNo="ngModel" [disabled]="isReadOnly"
                              (input)="validateEmployeeTotals('GME')" placeholder="General Member Number" maxlength="5"
                              (keypress)="allowOnlyPositiveIntegers($event)" (keypress)="validateNumber($event)"
                              (paste)="onPasteNumber($event)" [ngClass]="{ 'border-danger': hasIndividualMismatch }" />
                            <div class="text-danger" *ngIf="
                        generalMemberNo.invalid &&
                        (generalMemberNo.touched || generalMemberNo.dirty)
                      ">
                            </div>
                          </div>

                          <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">OBC Member No<span class="text-danger">*</span> </label>
                            <input type="text" class="form-control" name="oBCMemberNo" [(ngModel)]="empList.oBCMemberNo"
                              #oBCMemberNo="ngModel" [disabled]="isReadOnly" placeholder="OBC Member Number"
                              maxlength="5" (input)="validateEmployeeTotals('OM')"
                              (keypress)="allowOnlyPositiveIntegers($event)" (keypress)="validateNumber($event)"
                              (paste)="onPasteNumber($event)" (blur)="(0)"
                              [ngClass]="{ 'border-danger': hasIndividualMismatch }" />
                            <div class="text-danger" *ngIf="
                        oBCMemberNo.invalid &&
                        (oBCMemberNo.touched || oBCMemberNo.dirty)
                      ">
                            </div>
                          </div>

                          <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">SC Member No<span class="text-danger">*</span> </label>
                            <input type="text" class="form-control" name="scMemberNo" [(ngModel)]="empList.scMemberNo"
                              #scMemberNo="ngModel" [disabled]="isReadOnly" placeholder="SC Member Number" maxlength="5"
                              (input)="validateEmployeeTotals('SM')" (keypress)="allowOnlyPositiveIntegers($event)"
                              (keypress)="validateNumber($event)" (paste)="onPasteNumber($event)"
                              [ngClass]="{ 'border-danger': hasIndividualMismatch }" />
                            <div class="text-danger" *ngIf="
                        scMemberNo.invalid &&
                        (scMemberNo.touched || scMemberNo.dirty)
                      ">
                            </div>
                          </div>

                          <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">ST Member No <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" name="stMemberNo" [(ngModel)]="empList.stMemberNo"
                              #stMemberNo="ngModel" [disabled]="isReadOnly" placeholder="ST Member Number" maxlength="5"
                              (keypress)="allowOnlyPositiveIntegers($event)" (keypress)="validateNumber($event)"
                              (input)="validateEmployeeTotals('STM')" (paste)="onPasteNumber($event)"
                              [ngClass]="{ 'border-danger': hasIndividualMismatch }" />
                            <div class="text-danger" *ngIf="
                        stMemberNo.invalid &&
                        (stMemberNo.touched || stMemberNo.dirty)
                      ">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <!-- Committee Section -->
                  <div class="col-lg-12">
                    <div class="card">
                      <div class="card-header" style="border-left:0px;">
                        <h5 class="election-title">Management Committee Details</h5>
                      </div>
                      <div class="card-body">
                        <div class="row">


                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Total Committee Members No
                              <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" name="totalNoCommittee"
                              [(ngModel)]="empList.totalNoCommittee" #totalNoCommittee="ngModel"
                              (keypress)="allowOnlyNonNegativeIntegers($event)"
                              (paste)="allowOnlyNonNegativePaste($event)" [disabled]="isReadOnly" maxlength="5" required
                              placeholder="Committee Members No" [ngClass]="{ 'border-danger': hasCommitteeMismatch }"
                              (paste)="onPasteNumber($event)" />
                            <div class="text-danger" *ngIf="
                        totalNoCommittee.invalid &&
                        (totalNoCommittee.touched || totalNoCommittee.dirty)
                      ">
                              <div *ngIf="totalNoCommittee.errors?.['required']">
                                Total Committee Members No Required.
                              </div>

                            </div>
                          </div>
                          <div class="col-lg-12">
                            <hr>
                            <h5 class="election-title">Based on Position:</h5>
                          </div>
                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Total Number of Person on Positions<span
                                class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" name="totalPersonOnPositons"
                              [(ngModel)]="empList.totalPersonOnPositons" #totalPersonOnPositons="ngModel"
                              (input)="validateCommitteeTotals('TP')" [disabled]="isReadOnly" maxlength="5"
                              placeholder="Person on Positions No" max="9999"
                              (keypress)="allowOnlyPositiveIntegers($event)"
                              [ngClass]="{ 'border-danger': hasCommitteeMismatch }" (keypress)="validateNumber($event)"
                              (paste)="onPasteNumber($event)" />
                            <div class="text-danger" *ngIf="
                        totalPersonOnPositons.invalid &&
                        (totalPersonOnPositons.touched ||
                          totalPersonOnPositons.dirty)
                      ">

                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Number of Vacant Positions<span class="text-danger">*</span>
                              (If
                              Any)</label>
                            <input type="text" class="form-control" name="vacantPositions"
                              [(ngModel)]="empList.vacantPositions" #vacantPositions="ngModel"
                              (input)="validateCommitteeTotals('VP')" [disabled]="isReadOnly"
                              placeholder="Vacant Positions" maxlength="5"
                              (keypress)="allowOnlyPositiveIntegers($event)"
                              [ngClass]="{ 'border-danger': hasCommitteeMismatch }" (keypress)="validateNumber($event)"
                              (paste)="onPasteNumber($event)" />
                          </div>
                          <div class="col-lg-12">
                            <hr>
                            <h5 class="election-title">Based on Trained and Non-Trained:</h5>
                          </div>
                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Trained Member No <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" name="trainedmember"
                              [(ngModel)]="empList.trainedmember" maxlength="5" #trainedmember="ngModel"
                              (input)="validateCommitteeTotals('TMN')" [disabled]="isReadOnly"
                              (keypress)="allowOnlyPositiveIntegers($event)" placeholder="Trained Member No"
                              (keypress)="validateNumber($event)"
                              [ngClass]="{ 'border-danger': hasCommitteeMismatch }" />
                            <div class="text-danger" *ngIf="
                        trainedmember.invalid &&
                        (trainedmember.touched || trainedmember.dirty)
                      ">

                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Non-Trained Member No<span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" name="nonTrainedmember"
                              [(ngModel)]="empList.nonTrainedmember" maxlength="5" #nonTrainedmember="ngModel"
                              (input)="validateCommitteeTotals('NTM')" [disabled]="isReadOnly"
                              (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                              placeholder="Non-Trained Member No" (keypress)="validateNumber($event)"
                              [ngClass]="{ 'border-danger': hasCommitteeMismatch }" />
                            <div class="text-danger" *ngIf="
                        nonTrainedmember.invalid &&
                        (nonTrainedmember.touched || nonTrainedmember.dirty)
                      ">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Employee Section -->
                  <div class="col-lg-12">

                    <div class="card">
                      <div class="card-header" style="border-left:0px;">
                        <!-- <h5>Employee Details<sup>(financial year)</sup></h5> -->
                        <h5 class="election-title">Employee Details<sup class="fs-14px">({{ tempAuditYear }})</sup></h5>
                      </div>

                      <div class="card-body">
                        <div class="row">



                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Total Employees No
                              <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" name="totalNumberOfEmployess"
                              [(ngModel)]="empList.totalNumberOfEmployess" (paste)="allowOnlyNonNegativePaste($event)"
                              #totalNumberOfEmployees="ngModel" [disabled]="isReadOnly" required
                              placeholder="Total Employees No" maxlength="5"
                              (keypress)="allowOnlyNonNegativeIntegers($event)" (paste)="onPasteNumber($event)"
                              [ngClass]="{ 'border-danger': hasEmployeeMismatch }" />
                            <div class="text-danger" *ngIf="
                        totalNumberOfEmployees.invalid &&
                        (totalNumberOfEmployees.touched ||
                          totalNumberOfEmployees.dirty)
                      ">
                              <div *ngIf="totalNumberOfEmployees.errors?.['required']">
                                Total Employees No Required.
                              </div>
                              <div *ngIf="totalNumberOfEmployees.errors?.['max']">
                                Maximum value is 9999.
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12">
                            <hr>
                            <h5 class="election-title">Based on Trained and Non-Trained:</h5>
                          </div>

                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Trained Employees No<span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" name="trainedEmployees"
                              (input)="validateEmpTotals('TE')" [(ngModel)]="empList.trainedEmployees" maxlength="5"
                              #trainedEmployees="ngModel" [disabled]="isReadOnly"
                              (keypress)="allowOnlyPositiveIntegers($event)" placeholder="Trained Employees No"
                              maxlength="5" (paste)="onPasteNumber($event)" (keypress)="validateNumber($event)"
                              [ngClass]="{ 'border-danger': hasEmployeeMismatch }" />
                            <div class="text-danger" *ngIf="
                        trainedEmployees.invalid &&
                        (trainedEmployees.touched || trainedEmployees.dirty)
                      ">
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">Non-Trained Employees No<span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" name="nonTrainedEmployees"
                              [(ngModel)]="empList.nonTrainedEmployees" #nonTrainedEmployees="ngModel"
                              (input)="validateEmpTotals('NTE')" [disabled]="isReadOnly"
                              (keypress)="allowOnlyPositiveIntegers($event)" placeholder="Non-Trained Employees No"
                              maxlength="5" (paste)="onPasteNumber($event)" (keypress)="validateNumber($event)" />
                            <div class="text-danger" *ngIf="
                        nonTrainedEmployees.invalid &&
                        (nonTrainedEmployees.touched || nonTrainedEmployees.dirty)
                      ">
                            </div>
                          </div>
                          <!-- <div class="col-lg-6 col-md-6 mb-2">
                            <label class="form-label m-0">
                              Secretary Type <span class="text-danger">*</span>
                            </label>

                            <select class="form-control" [disabled]="isReadOnly" [(ngModel)]="empList.sectarytype"
                              name="sectarytype" #sectarytype="ngModel" required>
                              <option value="" disabled selected>
                                Select Secretary Type
                              </option>
                              <option value="Management Committee">
                                Management Committee
                              </option>
                              <option value="Employee">Employee</option>
                            </select>

                            <div *ngIf="sectarytype.invalid && sectarytype.touched" class="text-danger">
                              Please select Secretary Type.
                            </div>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Submit Buttons -->

                </div>

                <div class="d-flex justify-content-end gap-2" style="margin-top: 10px;">
                  <button type="button" (click)="goToTab('v-pills-SocietyInformation')" class="btn btn-secondary"
                    [style.display]="
                          hasSubmittedRemark ? 'none' : 'inline-block'
                        ">
                    Back
                  </button>
                  <!-- <button type="submit" class="btn btn-primary" [style.display]="
                          hasSubmittedRemark ? 'none' : 'inline-block'
                        " [disabled]="buttonDisable">

                      Save & Next
                    </button> -->
                  <button type="submit" class="btn btn-primary"
                    [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                    [disabled]="buttonDisable || isEmpSubmitting">

                    <span *ngIf="!isEmpSubmitting">Save & Next</span>
                    <span *ngIf="isEmpSubmitting">
                      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Saving...
                    </span>
                  </button>


                </div>
              </form>


            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="v-pills-SocietyServices" role="tabpanel"
          aria-labelledby="v-pills-SocietyServices-tab" tabindex="0">
          <div class="card">
            <div class="card-header">
              <h5 class="election-title">🧰 Society Services</h5>
            </div>

            <form #checklistForm="ngForm" (ngSubmit)="submitChecklistValue()" novalidate>
              <div class="card-body">
                <div class="row">
                  <!-- GST NO -->
                  <div class="col-6 mb-2" [style.display]="

                          hasSubmittedRemark && !commanPerameter.gstNo ? 'none' : 'inline-block' ">
                    <label class="form-label m-0">GST No</label>
                    <input type="text" class="form-control" [(ngModel)]="commanPerameter.gstNo" name="gstNo"
                      placeholder="Enter GST No" #gstNoControl="ngModel" [disabled]="isReadOnly"
                      pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$" minlength="15" maxlength="15"
                      (input)="commanPerameter.gstNo = commanPerameter.gstNo.toUpperCase()" />
                    <div *ngIf="gstNoControl.touched && gstNoControl.invalid" class="text-danger">

                      <div *ngIf="gstNoControl.errors?.['pattern']">
                        Invalid GST No format.
                      </div>
                      <div *ngIf="gstNoControl.errors?.['minlength'] || gstNoControl.errors?.['maxlength']">
                        GST No must be exactly 15 characters long.
                      </div>
                    </div>
                  </div>

                  <!-- PAN NO -->
                  <div class="col-6 mb-2" [style.display]="
                          hasSubmittedRemark && !commanPerameter.panNo ? 'none' : 'inline-block' ">
                    <label class="form-label m-0">PAN No</label>
                    <input type="text" class="form-control" [(ngModel)]="commanPerameter.panNo" name="panNo"
                      placeholder="Enter PAN No" #panNoControl="ngModel" [disabled]="isReadOnly"
                      pattern="^[A-Z]{5}[0-9]{4}[A-Z]{1}$" minlength="10" maxlength="10"
                      (input)="commanPerameter.panNo = commanPerameter.panNo.toUpperCase()" />
                    <div *ngIf="panNoControl.touched && panNoControl.invalid" class="text-danger">

                      <div *ngIf="panNoControl.errors?.['pattern']">
                        Invalid PAN No format.
                      </div>
                      <div *ngIf="panNoControl.errors?.['minlength'] || panNoControl.errors?.['maxlength']">
                        PAN No must be exactly 10 characters long.
                      </div>
                    </div>
                  </div>

                  <!-- TAN NO -->
                  <div class="col-6 mb-2" [style.display]="
                          hasSubmittedRemark && !commanPerameter.tanNo ? 'none' : 'inline-block' ">
                    <label class="form-label m-0">TAN No</label>
                    <input type="text" class="form-control" [(ngModel)]="commanPerameter.tanNo" name="tanNo"
                      placeholder="Enter TAN No" #tanNoControl="ngModel" [disabled]="isReadOnly"
                      pattern="^[A-Z]{4}[0-9]{5}[A-Z]{1}$" minlength="10" maxlength="10"
                      (input)="commanPerameter.tanNo = commanPerameter.tanNo.toUpperCase()" />
                    <div *ngIf="tanNoControl.touched && tanNoControl.invalid" class="text-danger">

                      <div *ngIf="tanNoControl.errors?.['pattern']">
                        Invalid TAN No format.
                      </div>
                      <div *ngIf="tanNoControl.errors?.['minlength'] || tanNoControl.errors?.['maxlength']">
                        TAN No must be exactly 10 characters long.
                      </div>
                    </div>
                  </div>

                  <!-- EPF NO -->
                  <div class="col-6 mb-2" [style.display]="
                          hasSubmittedRemark && !commanPerameter.epfNo ? 'none' : 'inline-block' ">
                    <label class="form-label m-0">EPF No</label>
                    <input type="text" class="form-control" [(ngModel)]="commanPerameter.epfNo" [disabled]="isReadOnly"
                      name="epfNo" placeholder="Enter EPF No"
                      (input)="commanPerameter.epfNo = commanPerameter.epfNo.toUpperCase()" #epfNoControl="ngModel"
                      minlength="5" maxlength="25" />
                  </div>

                  <div class="col-lg-12">
                    <hr>
                    <h5 class="election-title">Services</h5>
                  </div>
                  <div class="col-12 mb-2">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" [(ngModel)]="selectAll"
                        (change)="toggleAllServices()" [disabled]="isReadOnly" name="selectAllChk" />
                      <label class="form-check-label fw-bold">Select All</label>
                    </div>
                  </div>

                  <!-- Checkbox Section -->
                  <div class="col-lg-6" *ngFor="let service of lstBussinessUpgrades">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="service.checkd"
                        (change)="updateSelectedServices(service.id)" [name]="'checkbox_' + service.id"
                        [disabled]="isReadOnly" />
                      <label class="form-check-label">{{ service.name }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-body">
                <div class="col-lg-12">
                  <ng-container *ngFor="let ser of lstBussinessUpgrades">
                    <ng-container *ngIf="ser.checkd">
                      <div class="card">
                        <div class="card-header" style="border-left:0px;">
                          <h5 class="election-title">{{ ser.name }}</h5>
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <ng-container *ngIf="ser.groupedSubFields && ser.groupedSubFields.length > 0">
                              <ng-container *ngFor="let group of ser.groupedSubFields">
                                <div class="col-12 my-2" *ngIf="group.heading">
                                  <h6 class="text-secondary fw-bold">{{ group.heading }}</h6>
                                </div>

                                <ng-container
                                  *ngIf="group.fields && group.fields.length > 0; else handleGroupWithoutFields">
                                  <div class="row">
                                    <div class="col-md-6 mb-3" *ngFor="let subSer of group.fields">
                                      <label class="form-label">
                                        {{ subSer.labelName }}
                                        <span class="text-danger" *ngIf="subSer.isRequired">*</span>
                                      </label>

                                      <!-- <ng-container
                                        *ngIf="subSer.inputType?.toLowerCase() === 'dropdown'; else handleSubFieldInput">
                                        <select class="form-control" multiple [(ngModel)]="subSer.value"
                                          [disabled]="isReadOnly"
                                          [attr.name]="'field_' + ser.id + '_' + subSer.labelName"
                                          [required]="subSer.isRequired">
                                          <option *ngFor="let option of subSer.options" [ngValue]="option">{{ option }}
                                          </option>
                                        </select>
                                      </ng-container> -->
                                      <ng-container
                                        *ngIf="subSer.inputType?.toLowerCase() === 'dropdown'; else handleSubFieldInput">

                                        <div class="form-check mb-1">
                                          <input type="checkbox" class="form-check-input"
                                            [checked]="isAllSelected(group)" (change)="toggleSelectAll(group, $event)"
                                            [disabled]="isReadOnly" />
                                          <label class="form-check-label fw-bold">Select All</label>
                                        </div>

                                        <div class="form-check" *ngFor="let option of group.options">
                                          <input type="checkbox" class="form-check-input"
                                            [checked]="group.value?.includes(option)"
                                            (change)="onCheckboxChanges(group, option, $event)" [disabled]="isReadOnly"
                                            [name]="'field_' + ser.id + '_' + group.labelName + '_' + option" />
                                          <label class="form-check-label">
                                            {{ option }}
                                          </label>
                                        </div>

                                      </ng-container>

                                      <ng-template #handleSubFieldInput>
                                        <ng-container [ngSwitch]="subSer.inputType?.toLowerCase()">
                                          <ng-container *ngSwitchCase="'boolean'">
                                            <select class="form-control" [(ngModel)]="subSer.value"
                                              [name]="'field_' + ser.id + '_' + subSer.labelName"
                                              [disabled]="isReadOnly">
                                              <option [ngValue]="true">Yes</option>
                                              <option [ngValue]="false">No</option>
                                            </select>
                                          </ng-container>

                                          <ng-container *ngSwitchDefault>
                                            <ng-container
                                              *ngIf="subSer.labelName?.toLowerCase() === 'remark'; else defaultInput">
                                              <textarea class="form-control" [(ngModel)]="subSer.value"
                                                [name]="'sub_' + ser.id + '_' + subSer.labelName"
                                                [disabled]="isReadOnly" [placeholder]="'Enter ' + subSer.labelName"
                                                rows="3"></textarea>
                                            </ng-container>
                                            <ng-template #defaultInput>
                                              <input class="form-control" type="text"
                                                (keypress)="validateInput($event, subSer.inputType)"
                                                (paste)="onPaste($event, subSer.inputType)" [(ngModel)]="subSer.value"
                                                [name]="'sub_' + ser.id + '_' + subSer.labelName"
                                                [required]="subSer.isRequired" [disabled]="isReadOnly"
                                                [attr.maxlength]="(subSer.inputType === 'number' || subSer.inputType === 'digit') ? 5 : 50"
                                                [placeholder]="'Enter ' + subSer.labelName" />
                                            </ng-template>
                                          </ng-container>
                                        </ng-container>
                                      </ng-template>
                                    </div>
                                  </div>
                                </ng-container>

                                <ng-template #handleGroupWithoutFields>
                                  <div class="col-md-6 mb-3">
                                    <label class="form-label">
                                      {{ group.labelName }}
                                      <span class="text-danger" *ngIf="group.isRequired">*</span>
                                    </label>
                                    <ng-container [ngSwitch]="group.inputType?.toLowerCase()">
                                      <ng-container *ngSwitchCase="'boolean'">
                                        <select class="form-control" [(ngModel)]="group.value"
                                          [name]="'field_' + ser.id + '_' + group.labelName" [disabled]="isReadOnly"
                                          [required]="group.isRequired">
                                          <option [ngValue]="true">Yes</option>
                                          <option [ngValue]="false">No</option>
                                        </select>
                                      </ng-container>
                                      <!-- <ng-container *ngSwitchCase="'dropdown'">
                                        <select class="form-control" multiple [(ngModel)]="group.value"
                                          [name]="'field_' + ser.id + '_' + group.labelName" [disabled]="isReadOnly"
                                          [required]="group.isRequired">
                                          <option *ngFor="let option of group.options" [ngValue]="option">{{ option }}
                                          </option>
                                        </select>
                                      </ng-container> -->
                                      <ng-container *ngSwitchCase="'dropdown'">

                                        <div class="form-check mb-1">
                                          <input type="checkbox" class="form-check-input"
                                            [checked]="isAllSelected(group)" (change)="toggleSelectAll(group, $event)"
                                            [disabled]="isReadOnly" />
                                          <label class="form-check-label fw-bold">Select All</label>
                                        </div>

                                        <div class="form-check" *ngFor="let option of group.options">
                                          <input type="checkbox" class="form-check-input"
                                            [checked]="group.value?.includes(option)"
                                            (change)="onCheckboxChanges(group, option, $event)" [disabled]="isReadOnly"
                                            [name]="'field_' + ser.id + '_' + group.labelName + '_' + option" />
                                          <label class="form-check-label">
                                            {{ option }}
                                          </label>
                                        </div>

                                      </ng-container>

                                      <ng-container *ngSwitchDefault>
                                        <ng-container
                                          *ngIf="group.labelName?.toLowerCase() === 'remark'; else groupDefaultInput">
                                          <textarea class="form-control" [(ngModel)]="group.value"
                                            [name]="'field_' + ser.id + '_' + group.labelName"
                                            [required]="group.isRequired" [disabled]="isReadOnly"
                                            [placeholder]="'Enter ' + group.labelName" rows="3"></textarea>
                                        </ng-container>
                                        <ng-template #groupDefaultInput>
                                          <input class="form-control" type="text"
                                            (keypress)="validateInput($event, group.inputType)"
                                            (paste)="onPaste($event, group.inputType)" [(ngModel)]="group.value"
                                            [name]="'field_' + ser.id + '_' + group.labelName"
                                            [required]="group.isRequired" [disabled]="isReadOnly"
                                            [attr.maxlength]="(group.inputType === 'number' || group.inputType === 'digit') ? 5 : 50"
                                            [placeholder]="'Enter ' + group.labelName" />
                                        </ng-template>
                                      </ng-container>
                                    </ng-container>
                                  </div>

                                  <div *ngIf="group.inputType === 'boolean' && group.value === true" class="row mt-3">
                                    <div class="col-12" *ngFor="let groupItem of group.groupedConditionalFields">
                                      <div *ngIf="groupItem.heading && groupItem.heading !== 'General'" class="mb-2">
                                        <h6 class="fw-bold text-decoration-underline">{{ groupItem.heading }}</h6>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-6 mb-3" *ngFor="let cond of groupItem.fields">
                                          <label class="form-label">
                                            {{ cond.labelName }}
                                            <span class="text-danger" *ngIf="cond.isRequired">*</span>
                                          </label>
                                          <ng-container
                                            *ngIf="cond.labelName?.toLowerCase() === 'remark'; else condDefaultInput">
                                            <textarea class="form-control" [(ngModel)]="cond.value"
                                              [name]="'cond_' + ser.id + '_' + cond.labelName"
                                              [required]="cond.isRequired" [disabled]="isReadOnly"
                                              [placeholder]="'Enter ' + cond.labelName" rows="3"></textarea>
                                          </ng-container>
                                          <ng-template #condDefaultInput>
                                            <input class="form-control" type="text"
                                              (keypress)="validateInput($event, cond.inputType)"
                                              (paste)="onPaste($event, cond.inputType)" [(ngModel)]="cond.value"
                                              [name]="'cond_' + ser.id + '_' + cond.labelName"
                                              [required]="cond.isRequired" [disabled]="isReadOnly"
                                              [attr.maxlength]="cond.inputType === 'number' ? 9 : 50"
                                              [placeholder]="'Enter ' + cond.labelName" />
                                          </ng-template>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                              </ng-container>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>

                <!-- Action Buttons -->
                <div class="col-12 text-end mt-3">
                  <button type="button" class="btn btn-secondary" [style.display]="
                        hasSubmittedRemark ? 'none' : 'inline-block'
                      " (click)="goToTab('v-pills-MembersEmployeeDetails')">
                    Back
                  </button>
                  &nbsp;
                  <!-- <button type="submit" class="btn btn-primary" [disabled]="checklistForm.invalid" [style.display]="
                        hasSubmittedRemark ? 'none' : 'inline-block'
                      ">
                  Save & Next
                </button> -->
                  <button type="submit" class="btn btn-primary"
                    [disabled]="checklistForm.invalid || isChecklistSubmitting"
                    [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'">
                    <span *ngIf="!isChecklistSubmitting">Save & Next</span>
                    <span *ngIf="isChecklistSubmitting">
                      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Saving...
                    </span>
                  </button>

                </div>

              </div>



            </form>

          </div>
        </div>

        <div class="tab-pane fade" id="v-pills-AuditDetails" role="tabpanel" aria-labelledby="v-pills-AuditDetails-tab"
          tabindex="0">
          <div class="card">
            <div class="card-header">
              <h5 class="election-title">📊 Audit Details</h5>
            </div>
            <div class="card-body">
              <form #auditForm="ngForm" (ngSubmit)="submitAuditForm()" novalidate>
                <div class="row">
                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">Audit Year <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="tempAuditYear" id="sAuditYear"
                      name="sAuditYear" placeholder="Enter Audit Year" disabled />
                  </div>

                  <!-- Auditor Name -->
                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">
                      Auditor Name <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="allotDatas.fullName" name="auditorName"
                      placeholder="Auditor Name" disabled />
                  </div>

                  <!-- Audit Allotment Date -->
                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">
                      Audit Allotment Date <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="allotDatas.auditAllotDate"
                      name="auditAllotDate" placeholder="Audit Allotment Date" disabled />
                  </div>

                  <!-- Working Capital -->
                  <!-- Working Capital -->
                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">Working Capital <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" name="workingCapital" [(ngModel)]="auditList.workingCapital"
                      #workingCapital="ngModel" [disabled]="isReadOnly" required placeholder="Working Capital"
                      maxlength="15" (keypress)="validateNumber($event)" (paste)="onPasteNumber($event)"
                      (ngModelChange)="updateAuditClassification()" />
                    <div class="text-danger" *ngIf="
                        workingCapital.invalid &&
                        (workingCapital.touched || workingCapital.dirty)
                      ">
                      <div *ngIf="workingCapital.errors?.['required']">
                        Working Capital is required.
                      </div>

                    </div>
                  </div>

                  <!-- Audit Classification -->
                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">Audit Classification
                      <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" name="auditClassification" [disabled]="true"
                      [(ngModel)]="auditList.auditClassification" placeholder="Audit Classification" />
                  </div>
                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">Audit Start Date <span class="text-danger">*</span></label>

                    <!-- Editable Date Input with Template Variable and Validation -->
                    <ng-container>
                      <!-- <input type="date" class="form-control" name="auditStartDate" [disabled]="isReadOnly"
                        [(ngModel)]="auditList.auditStartDate" [max]="today" (keydown)="false" #auditStartDate="ngModel"
                        required /> -->

                      <input type="text" class="form-control" placeholder="dd/mm/yyyy" (keydown)="false"
                        [value]="auditList.auditStartDate ? (auditList.auditStartDate | date:'dd/MM/yyyy') : ''"
                        readonly [disabled]="isReadOnly" (click)="openPicker(startPicker)" />


                      <input #startPicker type="date" name="auditStartDate" [max]="today"
                        [(ngModel)]="auditList.auditStartDate"
                        style="position:absolute; opacity:0; pointer-events:none;" required #auditStartDate="ngModel" />



                      <!-- Validation messages -->
                      <div class="text-danger"
                        *ngIf="(auditStartDate.touched || auditStartDate.dirty) && (auditStartDate.invalid)">
                        <div *ngIf="auditStartDate.errors?.['required']">
                          Start Date is required.
                        </div>
                        <!-- <div *ngIf="validateDate(auditList.auditStartDate) === 'min'">
                        Audit Start date must be within the past last 1 years.
                      </div> -->

                      </div>

                    </ng-container>
                  </div>



                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">Audit Submission Date <span class="text-danger">*</span></label>

                    <!-- Editable Date Input with Template Variable and Validation -->
                    <ng-container>
                      <!-- <input type="date" class="form-control" name="submissionDate" [disabled]="isReadOnly"
                        [(ngModel)]="auditList.submissionDate" [min]="today" (keydown)="false" #submissionDate="ngModel"
                        required /> -->


                      <input type="text" class="form-control" placeholder="dd/mm/yyyy" (keydown)="false"
                        [value]="auditList.submissionDate ? (auditList.submissionDate | date:'dd/MM/yyyy') : ''"
                        readonly [disabled]="isReadOnly" (click)="openPicker(subPicker)" />


                      <input #subPicker type="date" name="submissionDate" [min]="today"
                        [(ngModel)]="auditList.submissionDate"
                        style="position:absolute; opacity:0; pointer-events:none;" required #submissionDate="ngModel" />
                      <!-- Validation messages -->
                      <div class="text-danger"
                        *ngIf="(submissionDate.touched || submissionDate.dirty) && (submissionDate.invalid )">
                        <div *ngIf="submissionDate.errors?.['required']">
                          Submission Date is required.
                        </div>

                      </div>


                    </ng-container>

                  </div>


                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">Last General House Meeting Date<span
                        class="text-danger">*</span></label>

                    <!-- Editable Date Input with Template Variable and Validation -->
                    <ng-container>
                      <!-- <input type="date" class="form-control" name="ghmDate" [disabled]="isReadOnly"
                        [(ngModel)]="auditList.ghmDate" [max]="today" (keydown)="false" #ghmDate="ngModel" required />
 -->
                      <input type="text" class="form-control" placeholder="dd/mm/yyyy" (keydown)="false"
                        [value]="auditList.ghmDate ? (auditList.ghmDate | date:'dd/MM/yyyy') : ''" readonly
                        [disabled]="isReadOnly" (click)="openPicker(ghmPicker)" />


                      <input #ghmPicker type="date" name="ghmDate" [max]="today" [(ngModel)]="auditList.ghmDate"
                        style="position:absolute; opacity:0; pointer-events:none;" required #ghmDate="ngModel" />


                      <!-- Validation messages -->
                      <div class="text-danger" *ngIf="(ghmDate.touched || ghmDate.dirty) && (ghmDate.invalid)">
                        <div *ngIf="ghmDate.errors?.['required']">
                          ghmDate Date is required.
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <!-- Election Date -->
                  <!-- 
                  <div class="col-lg-4 col-md-6 mb-2">
                    <label class="form-label m-0">Election Date <span class="text-danger">*</span></label>

                    <ng-container>
                      <input type="date" class="form-control" name="electionDate" [disabled]="isReadOnly"
                        [(ngModel)]="auditList.electionDate" [max]="today" (keydown)="false" #electionDate="ngModel"
                        required />



                      <div class="text-danger"
                        *ngIf="(electionDate.touched || electionDate.dirty) && (electionDate.invalid )">
                        <div *ngIf="electionDate.errors?.['required']">
                          electionDate is required.
                        </div>
                      </div>
                    </ng-container>
                  </div> -->

                  <!-- Action Buttons -->
                  <div class="col-lg-12">
                    <div class="d-flex align-items gap-2 justify-content-end">
                      <button type="button" class="btn btn-secondary" [style.display]="
                          hasSubmittedRemark ? 'none' : 'inline-block'
                        " (click)="goToTab('v-pills-SocietyServices')">
                        Back
                      </button>
                      <!-- <button type="submit" class="btn btn-primary" [disabled]="!auditListformIsValid" [style.display]="
                          hasSubmittedRemark ? 'none' : 'inline-block'
                        ">
                      Save & Next
                    </button> -->
                      <button type="submit" class="btn btn-primary"
                        [disabled]="!auditListformIsValid || isAuditSubmitting"
                        [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'">
                        <span *ngIf="!isAuditSubmitting">Save & Next</span>
                        <span *ngIf="isAuditSubmitting">
                          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                          Saving...
                        </span>
                      </button>

                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="v-pills-BalanceSheet" role="tabpanel" aria-labelledby="v-pills-BalanceSheet-tab"
          tabindex="0">
          <div class="card">
            <div class="card-header">
              <h5 class="election-title">📈 Balance Sheet</h5>
            </div>
            <div class="card-body">


              <div class="">
                <form #balanceForm="ngForm" (ngSubmit)="addBalanceList(balanceForm)">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">As on Date <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="asOnDate" [disabled]="isReadOnly"
                            [value]="balanceList.asOnDate ? (balanceList.asOnDate | date:'dd/MM/yyyy') : ''"
                            [max]="today" (keydown)="false" required />




                        </div>
                      </div>
                    </div>

               
                    <div class="col-lg-12">
                      <div class="row">

                        <div class="col-lg-4 col-md-6 mb-3">

                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <label class="form-label m-0" *ngIf="!allData.finalBalanceSheet?.[0]?.sUploadbalanceList">
                              Upload Balance Sheet <span class="text-danger">*</span>
                            </label>
                            <a *ngIf="allData.finalBalanceSheet?.[0]?.sUploadbalanceList"
                              class="btn btn-success btn-sm" style="cursor:pointer"
                              (click)="downloadFile(allData.finalBalanceSheet?.[0]?.sUploadbalanceList)">
                              <i class="fa fa-download me-1"></i> BalanceSheet Download
                            </a>

                            <div *ngIf="voterListBase64" class="d-flex gap-2">

                              <a class="text-primary small fw-semibold" style="cursor:pointer"
                                (click)="previewFile(voterListBase64,'IdentityDetails')">
                                View
                              </a>



                            </div>
                          </div>

                          <input *ngIf="!allData.finalBalanceSheet?.[0]?.sUploadbalanceList" type="file"
                            class="form-control" accept=".pdf" (change)="onFileChange($event,3)" />

                          <small *ngIf="!allData.finalBalanceSheet?.[0]?.sUploadbalanceList" class="text-muted">Type:
                            PDF | Max size: 2MB</small>
                        </div>



                        <div class="col-lg-4 col-md-6 mb-3">

                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <label class="form-label m-0" *ngIf="!this.allData?.finalBalanceSheet?.[0]?.sUploadRD">
                              Upload RD <span class="text-danger">*</span>
                            </label>

                            <a *ngIf="allData.finalBalanceSheet?.[0]?.sUploadRD" class="btn btn-success btn-sm"
                              style="cursor:pointer"
                              (click)="downloadFile(this.allData?.finalBalanceSheet?.[0]?.sUploadRD)">
                              <i class="fa fa-download me-1"></i>RD Download
                            </a>
                            <div *ngIf="rDfile64" class="d-flex gap-2">

                              <a class="text-primary small fw-semibold" style="cursor:pointer"
                                (click)="previewFile(rDfile64,'IdentityDetails2')">
                                View
                              </a>


                            </div>
                          </div>

                          <input *ngIf="!this.allData?.finalBalanceSheet?.[0]?.sUploadRD" type="file"
                            class="form-control" accept=".pdf" (change)="onFileChange($event,5)" />

                          <small *ngIf="!this.allData?.finalBalanceSheet?.[0]?.sUploadRD" class="text-muted">Type: PDF |
                            Max size: 2MB</small>
                        </div>



                        <div class="col-lg-4 col-md-6 mb-3">

                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <label class="form-label m-0" *ngIf="!this.allData?.finalBalanceSheet?.[0]?.sUploadpnL">
                              Upload PnL <span class="text-danger">*</span>
                            </label>
                            <a *ngIf="allData.finalBalanceSheet?.[0]?.sUploadpnL" class="btn btn-success btn-sm"
                              style="cursor:pointer"
                              (click)="downloadFile(this.allData?.finalBalanceSheet?.[0]?.sUploadpnL)">
                              <i class="fa fa-download me-1"></i>PnL Download
                            </a>
                            <div *ngIf="sUploadpnL64" class="d-flex gap-2">

                              <a class="text-primary small fw-semibold" style="cursor:pointer"
                                (click)="previewFile(sUploadpnL64,'IdentityDetails1')">
                                View
                              </a>



                            </div>
                          </div>

                          <input *ngIf="!this.allData?.finalBalanceSheet?.[0]?.sUploadpnL" type="file"
                            class="form-control" accept=".pdf" (change)="onFileChange($event,4)" />

                          <small *ngIf="!this.allData?.finalBalanceSheet?.[0]?.sUploadpnL" class="text-muted">Type: PDF
                            | Max size: 2MB</small>
                        </div>

                      </div>
                    </div>


                    <!-- Type -->
                    <div class="col-lg-4 col-md-6 mb-2" [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'">
                      <label class="form-label m-0">Type <span class="text-danger">*</span></label>
                      <select class="form-control" [(ngModel)]="balanceList.type" name="type"
                        (change)="GetHeadData(balanceList.type)" required #typeControl="ngModel">
                        <option [ngValue]="0" selected>Select Type</option>
                        <option [ngValue]="1">Liabilities</option>
                        <option [ngValue]="2">Assets</option>
                      </select>
                      <div *ngIf="typeControl.invalid && typeControl.touched" class="text-danger">Type is required.
                      </div>
                    </div>

                    <!-- Head -->
                    <div class="col-lg-4 col-md-6 mb-2" [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'">
                      <label class="form-label m-0">Head <span class="text-danger">*</span></label>
                      <select class="form-control" [(ngModel)]="balanceList.headID" name="headID"
                        (change)="GetSubheadData(balanceList.headID)" required #headIDControl="ngModel">
                        <option [ngValue]="0" disabled>Select Head</option>
                        <option *ngFor="let h of head" [ngValue]="h.id">{{ h.name }}</option>
                      </select>
                      <div *ngIf="headIDControl.invalid && headIDControl.touched" class="text-danger">Head is
                        required.
                      </div>
                    </div>

                    <!-- Sub-Head -->
                    <div class="col-lg-4 col-md-6 mb-2" [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'">
                      <label class="form-label m-0">Sub-Head <span class="text-danger">*</span></label>
                      <select class="form-control" [(ngModel)]="balanceList.subHeadID" name="subHeadID"
                        (change)="onSubHeadChange()" required #subHeadIDControl="ngModel">
                        <option [ngValue]="0" selected>Select Sub-Head</option>
                        <option *ngFor="let sh of subheads" [ngValue]="sh.id">{{ sh.name }}</option>
                      </select>
                      <div *ngIf="subHeadIDControl.invalid && subHeadIDControl.touched" class="text-danger">Sub-Head
                        is
                        required.</div>
                    </div>
                    <div class="modal fade" id="IdentityDetails">
                      <div class="modal-dialog modal-xl modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">Preview File</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                          </div>
                          <div class="modal-body text-center">


                            <iframe [src]="base64Pdf" style="width:100%; height:70vh; border:none;">
                            </iframe>


                            <img *ngIf="!voterListBase64?.includes('pdf')" [src]="voterListBase64"
                              style="max-width:100%; max-height:70vh;" />

                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="modal fade" id="IdentityDetails1">
                      <div class="modal-dialog modal-xl modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">Preview File</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                          </div>
                          <div class="modal-body text-center">


                            <iframe [src]="base64Pdf" style="width:100%; height:70vh; border:none;">
                            </iframe>


                            <img *ngIf="!sUploadpnL64?.includes('pdf')" [src]="sUploadpnL64"
                              style="max-width:100%; max-height:70vh;" />

                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="modal fade" id="IdentityDetails2">
                      <div class="modal-dialog modal-xl modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">Preview File</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                          </div>
                          <div class="modal-body text-center">


                            <iframe [src]="base64Pdf" style="width:100%; height:70vh; border:none;">
                            </iframe>


                            <img *ngIf="!rDfile64?.includes('pdf')" [src]="rDfile64"
                              style="max-width:100%; max-height:70vh;" />

                          </div>

                        </div>
                      </div>
                    </div>

                    <!-- Other Parameter -->
                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="selectedSubHeadNameValue === 'Other'">
                      <label class="form-label m-0">Other Parameter <span class="text-danger">*</span></label>
                      <input type="text" [(ngModel)]="balanceList.subHead" maxlength="50" name="otherParameter"
                        [disabled]="isReadOnly" class="form-control" placeholder="Enter Sub-Head"
                        (keypress)="allowOnlyNonNumeric($event)" />
                    </div>

                    <!-- Amount -->
                    <div class="col-lg-4 col-md-6 mb-2" [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'">
                      <label class="form-label m-0">Amount <span class="text-danger">*</span></label>
                      <input type="text" [(ngModel)]="balanceList.Amount" name="Amount" maxlength="15"
                        class="form-control" placeholder="Enter Amount" (ngModelChange)="processBalanceData($event)"
                        required #amountControl="ngModel" (keypress)="allowOnlyNonNegativeIntegers($event)"
                        (paste)="allowOnlyNonNegativePaste($event)" />
                      <div *ngIf="amountControl.invalid && amountControl.touched" class="text-danger">
                        Amount is required and must be a number.
                      </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="col-lg-12 mb-2 text-end">
                      <!-- <button type="submit" class="btn btn-outline-primary"
                      [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'">
                      Add
                    </button> -->
                      <button type="submit" class="btn btn-outline-primary" [disabled]="isBalanceSubmitting"
                        [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'">
                        <span *ngIf="!isBalanceSubmitting">Add</span>
                        <span *ngIf="isBalanceSubmitting">
                          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                          Saving...
                        </span>
                      </button>

                    </div>
                  </div>
                </form>
              </div>

              <div class="row">
                <!-- Liabilities Table -->
                <div class="col-lg-12 mt-3">
                  <h5>Liabilities</h5>
                  <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover"
                    [rows]="liabilityData" [columns]="column" [columnMode]="'force'" [headerHeight]="50"
                    [footerHeight]="50" rowHeight="auto" [count]="liabilityData.length" [limit]="10"
                    [scrollbarV]="false" [scrollbarH]="true" [loadingIndicator]="loading">

                    <ngx-datatable-column name="#" [sortable]="false" [width]="50">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
                        <span>{{ rowIndex + 1 }}</span>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngFor="let col of column" [name]="col.name" [prop]="col.prop"
                      [sortable]="true">
                      <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ value }}
                      </ng-template>
                    </ngx-datatable-column>

                    <!-- Action Column -->
                    <ngx-datatable-column name="Action" [sortable]="false" *ngIf="!hasSubmittedRemark">
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <button type="button" class="btn btn-danger btn-sm" (click)="confirmDelete(row.balanceSheetID)">
                          <i class="bi bi-trash3"></i>
                        </button>
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>

                  <!-- Liabilities Total -->
                  <div class="text-end mt-2">
                    <h5><strong>Total (Liabilities): ₹ {{ totalLiability | number: '1.2-2' }}</strong></h5>
                  </div>
                </div>

                <!-- Assets Table -->
                <div class="col-lg-12 mt-3">
                  <h5>Assets</h5>
                  <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover"
                    [rows]="assetData" [columns]="column" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
                    rowHeight="auto" [count]="assetData.length" [limit]="10" [scrollbarV]="false" [scrollbarH]="true"
                    [loadingIndicator]="loading">

                    <ngx-datatable-column name="#" [sortable]="false" [width]="50">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
                        <span>{{ rowIndex + 1 }}</span>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngFor="let col of column" [name]="col.name" [prop]="col.prop"
                      [sortable]="true">
                      <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ value }}
                      </ng-template>
                    </ngx-datatable-column>

                    <!-- Action Column -->
                    <ngx-datatable-column name="Action" [sortable]="false" *ngIf="!hasSubmittedRemark">
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <button type="button" class="btn btn-danger btn-sm" (click)="confirmDelete(row.balanceSheetID)">
                          <i class="bi bi-trash3"></i>
                        </button>
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>

                  <!-- Assets Total -->
                  <div class="text-end mt-2">
                    <h5><strong>Total (Assets): ₹ {{ totalAsset | number: '1.2-2' }}</strong></h5>
                  </div>
                </div>


              </div>


              <div class="col-lg-12" style="margin-top: 23px">
                <div class="d-flex align-items gap-2 justify-content-end">
                  <button type="button" class="btn btn-secondary"
                    [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                    (click)="goToTab('v-pills-AuditDetails')">
                    Back
                  </button>
                  <button type="button" (click)="next()" [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                    class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="v-pills-OtherDetails" role="tabpanel" aria-labelledby="v-pills-OtherDetails-tab"
          tabindex="0">
          <div class="card">
            <div class="card-header">
              <h5 class="election-title">📋 Other Details</h5>
            </div>
            <div class="card-body">
              <div class="row">

                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <!-- Income Field -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Turnover <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="income" required placeholder="Enter the income"
                            (keypress)="allowOnlyNonNegativeIntegers($event)"
                            (paste)="allowOnlyNonNegativePaste($event)" [(ngModel)]="otherList.income"
                            [disabled]="isReadOnly" #income="ngModel" maxlength="15" />
                          <div class="text-danger" *ngIf="income.invalid && income.touched">
                            Income is required.
                          </div>
                        </div>

                        <!-- Expenditure Field -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Total Expense <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="expenditure" required
                            (keypress)="allowOnlyNonNegativeIntegers($event)"
                            (paste)="allowOnlyNonNegativePaste($event)" placeholder="Enter the Expenditure"
                            [(ngModel)]="otherList.expenditure" [disabled]="isReadOnly" maxlength="15"
                            #expenditure="ngModel" />
                          <div class="text-danger" *ngIf="expenditure.invalid && expenditure.touched">
                            Expenditure is required.
                          </div>
                        </div>

                        <!-- Profit Field (visible only if profit exists) -->
                        <div class="col-lg-4 col-md-6 mb-2" *ngIf="isProfit || otherList.profit || otherParams?.profit">
                          <label class="form-label m-0">Total Net Profit</label>
                          <input type="text" class="form-control" name="profit" maxlength="15"
                            [(ngModel)]="otherList.profit" [disabled]="isReadOnly" readonly />
                        </div>

                        <!-- Loss Field (visible only if loss exists) -->
                        <div class="col-lg-4 col-md-6 mb-2" *ngIf="isLoss || otherList.loss || otherParams?.loss">
                          <label class="form-label m-0">Total Net Loss</label>
                          <input type="text" class="form-control" name="loss" maxlength="15"
                            [(ngModel)]="otherList.loss" [disabled]="isReadOnly" readonly />
                        </div>
                        <!-- Audit Fees -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Audit Fees <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="auditFees" required
                            [(ngModel)]="otherList.auditFees" #auditFees="ngModel" placeholder="Enter audit fees"
                            disabled />

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-header" style="border-left: 0px;">
                      <h5 class="election-title">Branch Details</h5>
                    </div>
                    <div class="card-body">
                      <div class="row">

                        <!-- Do you have Branches -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Do you have Branches<span class="text-danger">*</span></label>
                          <select class="form-control" [(ngModel)]="otherList.branches" name="hasBranches"
                            #hasBranches="ngModel" (change)="onBranchChange()" required [disabled]="isReadOnly">
                            <option [ngValue]="" disabled selected>
                              Select Option
                            </option>
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                          </select>

                          <!-- Validation error message -->
                          <div *ngIf="hasBranches.invalid && hasBranches.touched" class="text-danger">
                            Please select whether you have branches.
                          </div>
                        </div>

                        <!-- Number of Branches (visible only if branches is true) -->
                        <div class="col-lg-4 col-md-4 mb-2" *ngIf="otherList.branches == true">
                          <label class="form-label m-0">Number of Branches<span class="text-danger">*</span></label>
                          <input type="text" class="form-control" (paste)="onPasteNumber($event)"
                            [(ngModel)]="otherList.noOfBranches" name="noOfBranches" maxlength="15"
                            (keypress)="allowOnlyPositiveIntegers($event)" #noOfBranches="ngModel"
                            placeholder="Enter the number of branches" required [disabled]="isReadOnly"
                            maxlength="15" />

                          <div *ngIf="noOfBranches.invalid && noOfBranches.touched" class="text-danger">
                            Please enter the number of branches.
                          </div>
                        </div>

                        <!-- Audit Fees -->
                        <div class="col-lg-4 col-md-4 mb-2" *ngIf="otherList.branches == true">
                          <label class="form-label m-0">Branches Audit Fees
                            <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" (paste)="onPasteNumber($event)"
                            [disabled]="isReadOnly" name="bauditFees" required [(ngModel)]="otherList.bauditFees"
                            (keypress)="allowOnlyPositiveIntegers($event)" #bauditFees="ngModel" maxlength="15"
                            (ngModelChange)="updateTotalAuditFees()" placeholder="Enter audit fees" maxlength="15" />

                          <div class="text-danger" *ngIf="bauditFees.invalid && bauditFees.touched">
                            Branch Audit Fees is required
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-4 mb-2" *ngIf="otherList.branches == true">
                          <label class="form-label m-0">Total Audit Fee<span class="text-danger">*</span></label>
                          <input type="text" class="form-control" (paste)="onPasteNumber($event)"
                            [(ngModel)]="otherList.auditTFees" name="auditTFees" maxlength="15"
                            (keypress)="allowOnlyPositiveIntegers($event)" placeholder="Enter total audit Fees" readonly
                            [disabled]="isReadOnly" maxlength="15" />

                        </div>

                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Govt. Guarantee
                            <span class="text-danger">*</span></label>
                          <select class="form-control" name="guarantee" required [disabled]="isReadOnly" maxlength="15"
                            [(ngModel)]="otherList.guarantee">
                            <option [ngValue]="" disabled>
                              Select Govt. Guarantee
                            </option>
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                          </select>
                        </div>
                        <div class="col-lg-4 col-md-4 mb-2" *ngIf="otherList.guarantee == true">
                          <label class="form-label m-0">Total Amount<span class="text-danger">*</span></label>
                          <input type="text" class="form-control" (paste)="onPasteNumber($event)"
                            [(ngModel)]="otherList.totalamount" name="totalamount" maxlength="15"
                            (keypress)="allowOnlyPositiveIntegers($event)" #totalamount="ngModel"
                            placeholder="Enter the total Amount" required [disabled]="isReadOnly" maxlength="15" />

                          <div *ngIf="totalamount.invalid && totalamount.touched" class="text-danger">
                            Please enter the total Amount.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12" *ngIf="isGovtshare">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="election-title">Govt. Share Details</h5>
                    </div>

                    <div class="card-body">
                      <div class="row">

                        <!-- Govt. Share -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Govt. Share <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="govtShare" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the govt. share" [(ngModel)]="otherList.govtShare" readonly
                            [disabled]="isReadOnly" />

                        </div>

                        <!-- Redemption of Govt. Share -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Redemption of Govt. Share <span
                              class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="redemptionOfGovtShare" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the redemption of govt. share"
                            [(ngModel)]="otherList.redemptionOfGovtShare" #redemption="ngModel"
                            [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="redemption.invalid && redemption.touched">This field is
                            required
                          </div>
                        </div>

                        <!-- Govt. Dividend Payable -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Govt. Dividend Payable <span
                              class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="govtDividentPayable" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the govt. dividend payable" [(ngModel)]="otherList.govtDividentPayable"
                            #divPayable="ngModel" [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="divPayable.invalid && divPayable.touched">This field is
                            required
                          </div>
                        </div>

                        <!-- Govt. Dividend Paid -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Govt. Dividend Paid <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="govtDividentPaid" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the govt. dividend paid" [(ngModel)]="otherList.govtDividentPaid"
                            #divPaid="ngModel" [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="divPaid.invalid && divPaid.touched">This field is required
                          </div>
                        </div>

                        <!-- Govt. Loan -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Government Loan <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="govtLoan" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the govt. loan" [(ngModel)]="otherList.govtLoan" #govtLoan="ngModel"
                            [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="govtLoan.invalid && govtLoan.touched">Govt. Loan is required
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Government Loan Principal <span
                              class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="govtLoanPrincipal" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the govt. loan Principal" [(ngModel)]="otherList.govtLoanPrincipal"
                            #govtLoanPrincipal="ngModel" [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="govtLoanPrincipal.invalid && govtLoanPrincipal.touched">
                            Government Loan Principal is required
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Government Loan Interest<span
                              class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="govtLoanInterest" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the govt. loan Interest" [(ngModel)]="otherList.govtLoanInterest"
                            #govtLoanInterest="ngModel" [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="govtLoanInterest.invalid && govtLoanInterest.touched">
                            Government Loan Interest is required
                          </div>
                        </div>

                        <!-- Recovery of Principal -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Recovery of Principal <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="recoveryOfPrincipal" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the recovery of principal" [(ngModel)]="otherList.recoveryOfPrincipal"
                            #principal="ngModel" [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="principal.invalid && principal.touched">This field is required
                          </div>
                        </div>

                        <!-- Recovery of Interest -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label m-0">Recovery of Interest <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" name="recoveryOfInterest" required maxlength="15"
                            (paste)="onPasteNumber($event)" (keypress)="allowOnlyPositiveIntegers($event)"
                            placeholder="Enter the recovery of interest" [(ngModel)]="otherList.recoveryOfInterest"
                            #interest="ngModel" [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="interest.invalid && interest.touched">This field is required
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>


                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-header" style="border-left:0px;">
                      <h5 class="election-title">Misappropriation Details</h5>
                    </div>
                    <div class="card-body">
                      <div class="row">


                        <!-- Misappropriation -->
                        <div class="col-lg-6 col-md-6 mb-2">
                          <label class="form-label m-0">Misappropriation/Embezzlement
                            <span class="text-danger">*</span></label>
                          <select class="form-control" name="misappropriationEmbezzlement" required
                            (change)="onMisappropriationChange()" [disabled]="isReadOnly"
                            [(ngModel)]="otherList.misappropriationEmbezzlement">
                            <option [ngValue]="" disabled>
                              Select Misappropriation
                            </option>
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                          </select>
                        </div>

                        <!-- Date of Detection -->

                        <div class="col-lg-6 col-md-6 mb-2" *ngIf="otherList.misappropriationEmbezzlement === true">

                          <label class="form-label m-0"> Date of Detection<span class="text-danger">*</span></label>


                          <ng-container>
                            <input type="text" class="form-control" placeholder="dd/mm/yyyy"
                              [value]="otherList.dateOfDetection ? (otherList.dateOfDetection | date:'dd/MM/yyyy') : ''"
                              readonly [disabled]="isReadOnly" (click)="openPicker(dateOfDetectionPicker)" />

                            <input #dateOfDetectionPicker type="date" name="dateOfDetection" [max]="today"
                              [(ngModel)]="otherList.dateOfDetection"
                              style="position:absolute; opacity:0; pointer-events:none;" required
                              #dateOfDetection="ngModel" />

                            <div class="text-danger"
                              *ngIf="(dateOfDetection.touched || dateOfDetection.dirty) && dateOfDetection.invalid">
                              <div *ngIf="dateOfDetection.errors?.['required']">
                                Date Of Detection is required.
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <!-- Amount Involved -->
                        <div class="col-lg-6 col-md-6 mb-2" *ngIf="otherList.misappropriationEmbezzlement === true">
                          <label class="form-label m-0">Amount Involved <span class="text-danger">*</span></label>
                          <input type="text" class="form-control"
                            (ngModelChange)="checkMaxLength(otherList, 'amountInvolved', 15)"
                            (paste)="onPasteNumber($event)" name="amountInvolved" required
                            (keypress)="allowOnlyPositiveIntegers($event)" placeholder="Enter Amount Involved"
                            maxlength="15" [(ngModel)]="otherList.amountInvolved" #amount="ngModel"
                            [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="amount.invalid && amount.touched">
                            Amount is required
                          </div>
                          <div class="text-danger" *ngIf="errors['amountInvolved']">
                            {{ errors['amountInvolved'] }}
                          </div>
                        </div>

                        <div class="col-lg-6 col-md-6 mb-2" *ngIf="otherList.misappropriationEmbezzlement === true">
                          <label class="form-label m-0">Total Amount Recovered<span class="text-danger">*</span></label>
                          <input type="text" class="form-control"
                            (ngModelChange)="checkMaxLength(otherList, 'amountRecoverd', 15)"
                            (paste)="onPasteNumber($event)" name="amountRecoverd" required
                            (keypress)="allowOnlyPositiveIntegers($event)" placeholder="Enter Amount Recovered"
                            maxlength="15" [(ngModel)]="otherList.amountRecoverd" #amountRecoverd="ngModel"
                            [disabled]="isReadOnly" />
                          <div class="text-danger" *ngIf="amountRecoverd.invalid && amountRecoverd.touched">
                            Amount Recoverd is required
                          </div>
                          <div class="text-danger" *ngIf="errors['amountRecoverd']">
                            {{ errors['amountRecoverd'] }}
                          </div>
                        </div>
                        <!-- Special Report -->
                        <div class="col-lg-6 col-md-6 mb-2" *ngIf="otherList.misappropriationEmbezzlement === true">
                          <label for="specialReport" class="form-label m-0">Special Report <span
                              class="text-danger">*</span></label>
                          <select id="specialReport" class="form-control" name="specialReport" required
                            [(ngModel)]="otherList.specialReport" #specialReport="ngModel" [disabled]="isReadOnly">
                            <option [ngValue]="" disabled>
                              Select Report
                            </option>
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                          </select>
                          <div class="text-danger" *ngIf="specialReport.invalid && specialReport.touched">
                            Special Report is required.
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 mb-2" *ngIf="otherList.misappropriationEmbezzlement === true">
                          <label class="form-label m-0">Remarks<span class="text-danger">*</span></label>
                          <textarea class="form-control" [(ngModel)]="otherList.remark" placeholder="Enter Remarks"
                            required [disabled]="isReadOnly" #remark="ngModel" maxlength="250"></textarea>
                          <div *ngIf="remark.invalid && remark.touched" class="text-danger">Please enter land remarks.
                          </div>
                        </div>

                        <div class="col-lg-12">
                          <div class="d-flex align-items gap-2 justify-content-end">
                            <button type="button" class="btn btn-secondary" [style.display]="
                        hasSubmittedRemark ? 'none' : 'inline-block'
                      " (click)="goToTab('v-pills-BalanceSheet')">
                              Back
                            </button>

                            <!-- <button type="submit" [disabled]="!isFormDataValid()" [style.display]="
                        hasSubmittedRemark ? 'none' : 'inline-block'
                      " (click)="addOtherList()" class="btn btn-success">
                            Submit
                          </button> -->
                            <button type="submit" [disabled]="!isFormDataValid() || isOtherSubmitting"
                              [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'" (click)="addOtherList()"
                              class="btn btn-success">
                              <span *ngIf="!isOtherSubmitting">Submit</span>
                              <span *ngIf="isOtherSubmitting">
                                <span class="spinner-border spinner-border-sm me-1" role="status"
                                  aria-hidden="true"></span>
                                Submitting...
                              </span>
                            </button>

                          </div>
                        </div>

                      </div>



                      <!-- Modal Start-->
                      <div class="modal fade" id="checklistStatus" data-bs-backdrop="static" data-bs-keyboard="false"
                        tabindex="-1" aria-labelledby="checklistStatusLabel" aria-hidden="true">
                        <div class="modal-dialog">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h1 class="modal-title fs-5" id="checklistStatusLabel">
                                Status
                              </h1>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                (click)="restStatus()"></button>
                            </div>
                            <div class="modal-body">
                              <div class="row">
                                <div class="col-lg-6 mb-2">
                                  <label class="form-label m-0">Status<span class="text-danger">*</span></label>
                                  <select [(ngModel)]="newUpload.status" class="form-control" name="status" id="status"
                                    #statusAudit="ngModel" required>
                                    <option value="" disabled>Select Status</option>
                                    <option value="MoveForward">Move Forward</option>
                                  </select>
                                  <div *ngIf="statusAudit.touched && !newUpload.status" class="text-danger">
                                    Please select a status.
                                  </div>
                                </div>

                                <div class="col-lg-6 mb-2">

                                  <div class="d-flex justify-content-between align-items-center mb-1">
                                    <label class="form-label m-0" for="checklistStatusFile">Report Upload<span
                                        class="text-danger">*</span></label>

                                    <a *ngIf="reportUpload" href="javascript:void(0)"
                                      class="text-decoration-none text-primary small fw-semibold d-inline-flex align-items-center"
                                      (click)="previewFile(reportUpload,'IdentityDetails3')">
                                      <i>View</i>
                                    </a>
                                  </div>
                                  <input class="form-control" type="file" id="UploadReport"
                                    (change)="onFileChange($event,1)" [(ngModel)]="newUpload.documentPath"
                                    #documentPath="ngModel" required />
                                  <div *ngIf="
                                documentPath.touched && !newUpload.documentPath
                              " class="text-danger">
                                    Please upload a report.
                                  </div>
                                  <small class="form-text text-muted">
                                    types: pdf | Max size: 2 MB
                                  </small>
                                </div>

                                <div class="col-lg-12 mb-2">
                                  <label class="form-label m-0">Remarks<span class="text-danger">*</span></label>
                                  <textarea class="form-control" maxlength="250" rows="3" [(ngModel)]="newUpload.remark"
                                    name="remark" #remarkAudit="ngModel" required
                                    placeholder="Remarks Here..."></textarea>

                                  <div *ngIf="remarkAudit.touched && !newUpload.remark" class="text-danger">
                                    Please enter remarks.
                                  </div>
                                </div>


                                <div class="col-lg-12 mb-2">
                                  <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="DisclaimerAudit"
                                      [(ngModel)]="isDisclaimerChecked" name="disclaimer" style="
                                  transform: scale(1.2);
                                  accent-color: black;
                                  font-weight: bold;
                                " />
                                    <label class="form-check-label" for="DisclaimerAudit">
                                      <strong>Disclaimer:</strong> Before marking the
                                      report as prepared, read this carefully and check
                                      the box if you agree. If you tick the disclaimer,
                                      it means you have checked all the records
                                      carefully.
                                    </label>
                                  </div>
                                </div>
                                <div class="modal fade" id="IdentityDetails3">
                                  <div class="modal-dialog modal-xl modal-dialog-centered">
                                    <div class="modal-content">
                                      <div class="modal-header">
                                        <h5 class="modal-title">Preview File</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                                      </div>
                                      <div class="modal-body text-center">


                                        <iframe [src]="base64Pdf" style="width:100%; height:70vh; border:none;">
                                        </iframe>


                                        <img *ngIf="!reportUpload?.includes('pdf')" [src]="reportUpload"
                                          style="max-width:100%; max-height:70vh;" />

                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="modal-footer">
                              <!--
                            <button type="button" class="btn btn-success" [disabled]="!StatusFormValid()"
                              (click)="UpdateStatus()">
                              Submit
                            </button> -->
                              <button type="button" class="btn btn-success"
                                [disabled]="!StatusFormValid() || isStatusSubmitting" (click)="UpdateStatus()">
                                <span *ngIf="!isStatusSubmitting">Submit</span>
                                <span *ngIf="isStatusSubmitting">
                                  <span class="spinner-border spinner-border-sm" role="status"
                                    aria-hidden="true"></span>
                                  loading...
                                </span>
                              </button>

                            </div>
                          </div>
                        </div>
                        <!-- Modal End-->

                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Status Modal -->
  <div class="modal fade" id="AuditorStatus" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="AuditorStatusLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title" id="AuditorStatusLabel">
            <i class="bi bi-clock-history me-2"></i> Audit Status
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body p-3">

          <div class="card border shadow-sm">
            <div class="card-body p-3">
              <div class="step-progressbar">

                <div class="v-progress" style="max-height: 300px; overflow-y: auto;">
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let process of filteredStatus" class="list-group-item">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong class="text-dark">{{ process.roleName }}</strong>
                          <div class="text-muted small mt-1">
                            <strong class="text-danger">Action:</strong> {{ process.remarks }}
                          </div>
                        </div>
                        <div class="text-end">
                          <span class="badge bg-light text-dark border">
                            <strong class="text-danger">Date:</strong>
                            {{ process.dCreateDate | date:'dd/MM/yyyy' }}
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>